import { FC } from "react";
import { useTranslation } from "react-i18next";
import { NextArrowIcon, PlaneTakeoffIcon } from "src/assets/Icons";
import { SegmentType } from "src/Modules/Flights/constants";
import { explode, formatTimeFromUnit } from "src/utility";
import { formatDate } from "src/utility/time";

const SegmentHeader: FC<{ segmentNumber: number; segment: SegmentType }> = ({ segment, segmentNumber }) => {
  const { t } = useTranslation();
  const { origin, destination, durationMinutes, departure, stops, flights } = explode(segment, {});
  const imgUrl = flights?.[0]?.airlineImage;
  const parsedDeparture = formatDate(departure, "DD MMM hh:mm A");
  const duration = formatTimeFromUnit(durationMinutes, "m");
  const title = segmentNumber === 0 ? <span>{t("Flights.details.flightPath.departureTrip")} </span> : <span> {t("Flights.details.flightPath.returnTrip")} </span>;
  const stopsTitle =
    stops === 0 ? t("Flights.details.flightPath.directFlight") : stops === 1 ? t("Flights.listing.oneStop") : t("Flights.listing.multipleStops", { count: stops });

  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex flex-col gap-0.5">
        <div className="text-font-default text-sm font-semibold md:text-base">
          {title} {stopsTitle}
        </div>
        <div className="text-font-subtle flex items-center gap-2 text-xs font-medium whitespace-nowrap">
          <div className="flex items-center gap-1">
            {origin} <NextArrowIcon className="h-2 w-3" /> {destination}
          </div>
          <div className="bg-icon-subtle h-1 w-1 rounded-full"></div>
          <div>{parsedDeparture}</div>
        </div>
      </div>
      <div className="bg-background-primary-lighter text-font-active flex flex-wrap items-center gap-1 rounded-full px-3 py-1.5 text-xs font-semibold whitespace-nowrap">
        <div className="uppercase">{t("Flights.details.flightPath.totalDuration")}: </div>
        <div>{duration}</div>
      </div>
    </div>
  );
};

export default SegmentHeader;